import { volume } from "@/state/config";
import type { FunctionalComponent } from "preact";
import Headline from "../Headline";

export interface Props {
    headline: string;
    class?: string;
}

const Volume: FunctionalComponent<Props> = (props) => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const onChange = (e: any) => {
        if (e.target?.value !== null) {
            volume.value = e.target?.value / 100;
        }
    };

    return (
        <div class={`w-full ${props.class}`}>
            <Headline text={props.headline} />
            <div class="mt-1 block w-full rounded-md border-0 bg-white px-4 py-2 text-gray-900 text-xs focus:ring-[#00c3e3]">
                <input
                    class="slider w-full select-none appearance-none bg-transparent"
                    type="range"
                    name=""
                    value={volume.value * 100}
                    min="0"
                    max="100"
                    onInput={onChange}
                />
                <div class="-mt-1 flex w-full select-none justify-between">
                    <span class="text-gray-900 text-xs">0</span>
                    <span class="text-gray-900 text-xs">100</span>
                </div>
            </div>
        </div>
    );
};

export default Volume;
